import { Tabs } from '@mantine/core';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Employees from './Employees';
import Organization from './Organization';
import { useAdminStore } from '@/store/admin';

const AdminConsole = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<'employees' | 'organization'>('employees');
  const {
    companyId,
    fetchDepartmentByCompanyId,
    fetchUserList,
    fetchCompanyProfileInfo,
    fetchCompanySetting,
    fetchAuthorityRoles,
    isDataReady,
    isDataLoading,
    fetchAllAdminData,
  } = useAdminStore((state) => state);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    // 数据初始化现在由 Layout 组件统一处理
    // 如果数据未准备好，等待 Layout 组件完成初始化
    if (!isDataReady && !isDataLoading) {
      console.log('[AdminConsole] Waiting for data initialization from Layout...');
    }
  }, [isDataReady, isDataLoading]);

  useEffect(() => {
    if (companyId && isDataReady) {
      // 只在数据已准备好时获取公司相关信息，避免与fetchAllAdminData重复
      console.log('[AdminConsole] Fetching company profile and settings...');
      fetchCompanyProfileInfo({ companyId });
      fetchCompanySetting({ companyId });

      // 注意：fetchDepartmentByCompanyId和fetchAuthorityRoles已在fetchAllAdminData中处理
      // 这里不再重复调用，避免重复请求
    }
  }, [companyId, isDataReady, fetchCompanyProfileInfo, fetchCompanySetting]);

  const handleTabChange = (value: string | null) => {
    if (value === 'employees' || value === 'organization') {
      setActiveTab(value);
      if (value === 'employees') {
        setCurrentPage(1);
        // 只在需要时获取用户列表，避免重复
        if (companyId) {
          fetchUserList({ currentPage: 1, pageSize: 10, companyId, enabled: null });
        }
      }
    }
  };

  // 如果数据正在加载或未准备好，显示加载状态
  if (isDataLoading || !isDataReady) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-gray-500">{t('adminConsole.loading')}</div>
      </div>
    );
  }

  return (
    companyId && (
      <div>
        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tabs.List>
            <Tabs.Tab value="employees">{t('adminConsole.tab.employees')}</Tabs.Tab>
            <Tabs.Tab value="organization">{t('adminConsole.tab.organization')}</Tabs.Tab>
          </Tabs.List>
          <Tabs.Panel value="employees">
            <Employees currentPage={currentPage} setCurrentPage={setCurrentPage} />
          </Tabs.Panel>
          <Tabs.Panel value="organization" className="pb-10">
            <Organization />
          </Tabs.Panel>
        </Tabs>
      </div>
    )
  );
};

export default AdminConsole;
